
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import { useTranslation } from "react-i18next";

interface SearchInputProps {
	value: string;
	onChange: (value: string) => void;
}

export default function SearchInput({ value, onChange }: SearchInputProps) {
	const { t } = useTranslation();

	return (
		<TextField
			size="small"
			hiddenLabel
			id="outlined-basic"
			variant="outlined"
			value={value}
			onChange={(e) => onChange(e.target.value)}
			color="success"
			placeholder={t("addressEncoding.search")}
			InputProps={{
				startAdornment: (
					<InputAdornment position="start">
						<span className="material-icons-outlined">search</span>
					</InputAdornment>
				),
				endAdornment: (
					<InputAdornment position="end">
						{value && (
							<IconButton
								aria-label="clear search"
								onClick={() => onChange("")}
								edge="end"
								size="small"
							>
								<span className="material-icons-outlined" style={{ fontSize: "16px" }}>close</span>
							</IconButton>
						)}
					</InputAdornment>
				)
			}}
			style={{ margin: "10px",  width: "30%" }}
			sx={{
				'& .MuiOutlinedInput-root': { height: 35.6 },
				'& .MuiOutlinedInput-input': { padding: '2px 8px', fontSize: 12, lineHeight: 1.2 },
			}}
		/>
	);
}